import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Blog } from '@/commonTypes';

import { useLocale, useTranslations } from 'next-intl';
import SectionHead from '@/components/general/SectionHead';
import { Breadcrumb } from '@/components/general/BreadCrumb';

export default function BlogHead({ data }: { data?: Blog }) {
  const locale = useLocale();
  const t = useTranslations('blog');
  const tCommon = useTranslations('common');

  return (
    <>
      <Breadcrumb
        className={styles.breadCrumb}
        items={[
          { label: tCommon('homeTitle'), to: '/' },
          { label: tCommon('seo.blog.title'), to: '/blogs' },
          { label: data?.title || '' },
        ]}
      />
      <SectionHead
        title={data?.title}
        text={data?.excerpt}
        textTag="h2"
        tag={data?.category?.name}
        headingTag="h1"
        type="otherPages"
        // position={'center'}
        titleClass={`${styles.titleClass}`}
        // wrapper={`${styles.wrapper}`}
      />
    </>
  );
}
